export default __webpack_public_path__ + "static/fine-tuned-llama-9d27c81d8168ca4347e36f1de1c83515.png";